import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import 'store/tracking';
import { joinClasses, joinPaths } from 'utils/utils';
import { loadPage, getPageComponent, PAGE_ERROR, PAGE_LOADING } from 'utils/pageComponents';
import { geoFromIP } from 'utils/geo';
import { getPageCanonicalLink, getPageTitle } from 'utils/metaData';

import Header from 'components/header/header';
import Footer from 'components/footer/footer';

import s from 'base/universalHub/universalHubApp.sss';

const isServer = typeof window === 'undefined';

export default class UniversalHubApp extends Component {
	constructor(props) {
		super(props);

		this.state = {
			appState: props.initialStore,
		};

		this.setActivePageFromURL = this.setActivePageFromURL.bind(this);
		this.onClick = this.onClick.bind(this);

		Store.set(props.initialStore);
		Store.on('update', () => this.setState({ appState: Store.get() }));

		if (!isServer) {
			this.loadPage();
			this.getUserGeo();
			Store.emit(actions.LANDING, { page: this.getActivePageData() });
		}
	}

	componentDidMount() {
		window.addEventListener('popstate', this.setActivePageFromURL);
	}

	componentWillUpdate(nextProps, nextState) {
		if (nextState.appState.activePage !== this.state.appState.activePage) {
			this.loadPage(nextState.appState.activePage);
			// const pages = Object.values(this.state.appState.appData.pages || {}).filter(p => !p.base || p.base === 'universalHub');
			Store.emit(actions.ACTIVE_PAGE_UPDATED, { page: this.getActivePageData(nextState) });
		}
	}

	componentWillUnmount() {
		window.removeEventListener('popstate', this.setActivePageFromURL);
	}

	async getUserGeo() {
		const geo = await geoFromIP();
		Store.get().client.set('geo', geo);
		Store.emit('GEOLOCATION', geo);
	}

	getActivePage(state = this.state) {
		return state.appState.activePage;
	}
	getActivePageData(state = this.state) {
		return state.appState.appData.pages?.[this.getActivePage(state)];
	}

	async loadPage(page = this.getActivePage()) {
		await loadPage(page);
		if (page === this.getActivePage()) {
			this.forceUpdate();
		}
	}

	setActivePageFromURL(e) {
		if (e?.type === 'popstate' && /^\/movies\/([^/]+)\//.test(location.pathname)) {
			location.reload();
			return;
		}

		// TODO: cache url -> id mappings ?
		const pages = Object.values(this.state.appState.appData.pages || {}).filter(p => !p.base || p.base === 'universalHub');
		const currentPath = '/' + (location.origin + location.pathname).replace(window.__BASE_URL__, '').replace(/index\.html$/, '');
		const destination = pages.find(p => currentPath === p.path + (p.baseHtml && p.baseHtml !== 'index.html' ? p.baseHtml : ''));

		if (destination && this.getActivePage() !== destination.id) {
			// Scroll to top ?
			window.scrollTo(0, 0);
			Store.get().set({ activePage: destination.id });
		}

		// Some pages might change title/canonical link even without changing (e.g. leadership when clicking on a name)
		if (destination) {
			const title = getPageTitle(destination);
			document.title = title;
			document.querySelector('meta[property="og:title"]')?.setAttribute('content', title);
			document.querySelector('link[rel="canonical"]')?.setAttribute('href', getPageCanonicalLink(destination));
		}
		window.dispatchEvent(new CustomEvent('powster-navigation'));
	}

	onClick(e) {
		const link = e.target.closest('a');
		if (!link) return;
		const target = link.target || '_self';
		if (target !== '_self' || link.origin !== location.origin) return;
		// TODO: maybe also check if it's a /movies/slug/ link (and return to use normal navigation if so)
		// TODO: cache
		const pages = this.state.appState.appData.pages || {};
		const links = Object.fromEntries(Object.entries(pages).map(([id, { path }]) => [joinPaths(window.__BASE_URL__, path || ''), id]));
		const desired = link.origin + link.pathname;
		const destination = links[desired];
		if (destination) {
			e.preventDefault();
			history.pushState(null, '', link.href);
			this.setActivePageFromURL();
		}
	}

	renderLoading() {
		return <div class={s.loading} key="loading" />;
	}

	renderError() {
		// TODO: improve (maybe external component?)
		return <div class={s.error} key="error">Error loading page</div>;
	}

	renderPage() {
		if (isServer) return this.renderLoading();
		const activePage = this.getActivePage();
		const Page = getPageComponent(activePage);
		if (!Page) return;
		// TODO: improve loading/error screens (maybe external components?)
		if (Page === PAGE_LOADING) return this.renderLoading();
		if (Page === PAGE_ERROR) return this.renderError();
		return <Page key={activePage} />;
	}

	render(props, state) {
		return (
			<div class={joinClasses(s.container)} id="universalHub" onClickCapture={this.onClick}>
				<Header />
				{this.renderPage()}
				<Footer />
			</div>
		);
	}
}
